// src/components/BoardOfEd/components/Program2700.jsx
import React from "react";
import { ProgramBudget } from "../../../../budget/model/program/ProgramBudget.jsx";

export const PROGRAM_2700_CONFIG = {
  fullName: "SPECIAL EDUCATION",
  docId: "2700",

  fieldDefs: [
    // ========= POSITIONS (FTE) =========
    {
      key: "positionsAdmin",
      label: "Positions – Administrative",
      valueType: "count",
      sources: [{ block: "Positions", key: "Administrative" }],
      group: "positions",
      defaultVisible: false,
    },
    {
      key: "positionsSpecialEdTeachers",
      label: "Positions – Special Ed Teachers",
      valueType: "count",
      sources: [{ block: "Positions", key: "Special Ed Teachers" }],
      group: "positions",
      defaultVisible: false,
    },
    {
      key: "positionsSpeechTeachers",
      label: "Positions – Speech Teachers",
      valueType: "count",
      sources: [{ block: "Positions", key: "Speech Teachers" }],
      group: "positions",
      defaultVisible: false,
    },
    {
      key: "positionsPsychologists",
      label: "Positions – Psychologists",
      valueType: "count",
      sources: [{ block: "Positions", key: "Psychologists" }],
      group: "positions",
      defaultVisible: false, // only exists in later years
    },
    {
      key: "positionsSocialWorkerBCBA",
      label: "Positions – Social Worker / BCBA",
      valueType: "count",
      sources: [{ block: "Positions", key: "Social Worker / BCBA" }],
      group: "positions",
      defaultVisible: false,
    },
    {
      key: "positionsSecretarial",
      label: "Positions – Secretarial",
      valueType: "count",
      sources: [{ block: "Positions", key: "Secretarial" }],
      group: "positions",
      defaultVisible: false,
    },
    {
      key: "positionsParaEducators",
      label: "Positions – ParaEducators",
      valueType: "count",
      sources: [{ block: "Positions", key: "ParaEducators" }, { block: "Positions", key: "Paraeducators" }],
      group: "positions",
      defaultVisible: false,
    },
    {
      key: "positionsDriversGeneralServices",
      label: "Positions – General Services Drivers",
      valueType: "count",
      sources: [{ block: "Positions", key: "General Services Drivers" }],
      group: "positions",
      defaultVisible: false,
    },
    {
      key: "positionsCertifiedIDEAB",
      label: "Positions – Certified (IDEA B Grant)",
      valueType: "count",
      sources: [{ block: "Positions", key: "Certified - IDEA B Grant" }],
      group: "positions",
      defaultVisible: false,
    },
    {
      key: "positionsClassifiedIDEAB",
      label: "Positions – Classified (IDEA B Grant)",
      valueType: "count",
      sources: [{ block: "Positions", key: "Classified - IDEA B Grant" }],
      group: "positions",
      defaultVisible: false,
    },
    {
      key: "positionsTeacherPreschoolGrant",
      label: "Positions – Teacher (Pre-School Grant)",
      valueType: "count",
      sources: [{ block: "Positions", key: "Teacher - Pre-School Grant" }],
      group: "positions",
      defaultVisible: false,
    },

    // ========= SALARIES =========
    {
      key: "salariesAdmin",
      label: "Salaries – Administrative",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Administrative" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesSpecialEdTeachers",
      label: "Salaries – Teachers (Special Ed)",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Teachers (Special Ed)" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesSpeechTeachers",
      label: "Salaries – Teachers (Speech)",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Teachers (Speech)" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesPsychologists",
      label: "Salaries – Psychologists",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Psychologists" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesSocialWorkerBCBA",
      label: "Salaries – Social Worker / BCBA",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Social Worker / BCBA" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesSecretarial",
      label: "Salaries – Secretarial",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Secretarial" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesParaEducators",
      label: "Salaries – ParaEducators",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "ParaEducators" }, { block: "Salaries", key: "Paraeducators" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesTutors",
      label: "Salaries – Tutors",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Tutors" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesParaEducatorsPT",
      label: "Salaries – ParaEducators, P-T",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "ParaEducators, P-T" }, { block: "Salaries", key: "Paraeducators, P-T" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesOccupPhysTherapy",
      label: "Salaries – Occup./Phys. Therapy",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Occup./Phys. Therapy" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesVanDriversMonitors",
      label: "Salaries – Van Drivers/Monitors",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Van Drivers/Monitors" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesDriversGeneralServices",
      label: "Salaries – Drivers (General Services)",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Drivers (General Services)" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesAltAfterSchool",
      label: "Salaries – Alt. After-School Programs",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Alt. After-School Programs" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesSummerPrograms",
      label: "Salaries – Summer Programs",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Summer Programs" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "fieldTrips",
      label: "Field Trips",
      valueType: "currency",
      sources: [
        { block: "Salaries", key: "Field Trips" },
        { block: "Supplies / Materials", key: "Field Trips" },
      ],
      group: "salaries",
      defaultVisible: false,
    },

    // ========= PURCHASED SERVICES =========
    {
      key: "psVehicleRental",
      label: "Vehicle Rental",
      valueType: "currency",
      sources: [{ block: "Purchased Services", key: "Vehicle Rental" }],
      group: "purchased Services",
      defaultVisible: false,
    },
    {
      key: "psTuition",
      label: "Tuition",
      valueType: "currency",
      sources: [{ block: "Purchased Services", key: "Tuition" }],
      group: "purchased Services",
      defaultVisible: false,
    },
    {
      key: "psModularClassroomLinks",
      label: "Modular Classroom Links",
      valueType: "currency",
      sources: [{ block: "Purchased Services", key: "Modular Classroom Links" }],
      group: "purchased Services",
      defaultVisible: false,
    },
    {
      key: "psAudiologicalMntc",
      label: "Audiological Mntc.",
      valueType: "currency",
      sources: [{ block: "Purchased Services", key: "Audiological Mntc." }],
      group: "purchased Services",
      defaultVisible: false,
    },
    {
      key: "psCochlearImplantSupport",
      label: "Cochlear Implant Support",
      valueType: "currency",
      sources: [{ block: "Purchased Services", key: "Cochlear Implant Support" }],
      group: "purchased Services",
      defaultVisible: false,
    },
    {
      key: "psInterpreterServices",
      label: "Interpreter Services",
      valueType: "currency",
      sources: [{ block: "Purchased Services", key: "Interpreter Services" }],
      group: "purchased Services",
      defaultVisible: false,
    },
    {
      key: "psHearingImpaired",
      label: "Hearing Impaired",
      valueType: "currency",
      sources: [{ block: "Purchased Services", key: "Hearing Impaired" }],
      group: "purchased Services",
      defaultVisible: false,
    },
    {
      key: "psEvaluations",
      label: "Evaluations",
      valueType: "currency",
      sources: [{ block: "Purchased Services", key: "Evaluations" }],
      group: "purchased Services",
      defaultVisible: false,
    },
    {
      key: "psWorkExperienceProgram",
      label: "Work Experience Program",
      valueType: "currency",
      sources: [{ block: "Purchased Services", key: "Work Experience Program" }],
      group: "purchased Services",
      defaultVisible: false,
    },
    {
      key: "psLegalFees",
      label: "Legal Fees",
      valueType: "currency",
      sources: [{ block: "Purchased Services", key: "Legal Fees" }],
      group: "purchased Services",
      defaultVisible: false,
    },

    // ========= SUPPLIES / MATERIALS =========
    {
      key: "supplies",
      label: "Supplies",
      valueType: "currency",
      sources: [{ block: "Supplies / Materials", key: "Supplies" }],
      group: "materials",
      defaultVisible: false,
    },

    // ========= OTHER / OFFSETS =========
    {
      key: "duesFees",
      label: "Dues / Fees",
      valueType: "currency",
      sources: [
        { block: "Other", key: "Dues & Fees" },
        { block: "Other", key: "Dues/Fees" },
        { block: "Other", key: "Dues and Fees" },
      ],
      group: "other",
      defaultVisible: false,
    },
    {
      key: "excessCostOffset",
      label: "Excess Cost Offset",
      valueType: "currency",
      sources: [
        { block: "Other", key: "Excess Cost Offset" },   // e.g. 2021, 2023, 2024 Approved
        { block: "Offsets", key: "Excess Cost Offset" }, // 2025 Approved
      ],
      group: "other",
      defaultVisible: false,
    },
  ],

  tables: [
    {
      id: "approved",
      title: "Approved Budget",
      sectionKey: "Approved",
      fields: [
        // Positions
        "positionsAdmin",
        "positionsSpecialEdTeachers",
        "positionsSpeechTeachers",
        "positionsPsychologists",
        "positionsSocialWorkerBCBA",
        "positionsSecretarial",
        "positionsParaEducators",
        "positionsDriversGeneralServices",
        "positionsCertifiedIDEAB",
        "positionsClassifiedIDEAB",
        "positionsTeacherPreschoolGrant",

        // Salaries
        "salariesAdmin",
        "salariesSpecialEdTeachers",
        "salariesSpeechTeachers",
        "salariesPsychologists",
        "salariesSocialWorkerBCBA",
        "salariesSecretarial",
        "salariesParaEducators",
        "salariesTutors",
        "salariesParaEducatorsPT",
        "salariesOccupPhysTherapy",
        "salariesVanDriversMonitors",
        "salariesDriversGeneralServices",
        "salariesAltAfterSchool",
        "salariesSummerPrograms",
        "fieldTrips",

        // Purchased Services
        "psVehicleRental",
        "psTuition",
        "psModularClassroomLinks",
        "psAudiologicalMntc",
        "psCochlearImplantSupport",
        "psInterpreterServices",
        "psHearingImpaired",
        "psEvaluations",
        "psWorkExperienceProgram",
        "psLegalFees",

        // Supplies / Materials
        "supplies",

        // Other / Offsets
        "duesFees",
        "excessCostOffset",
      ],
      columnStyles: {
        year: { width: "100px", minWidth: "100px" },

        // Positions
        positionsAdmin: { minWidth: "120px" },
        positionsSpecialEdTeachers: { minWidth: "150px" },
        positionsSpeechTeachers: { minWidth: "150px" },
        positionsPsychologists: { minWidth: "130px" },
        positionsSocialWorkerBCBA: { minWidth: "150px" },
        positionsSecretarial: { minWidth: "110px" },
        positionsParaEducators: { minWidth: "120px" },
        positionsDriversGeneralServices: { minWidth: "160px" },
        positionsCertifiedIDEAB: { minWidth: "160px" },
        positionsClassifiedIDEAB: { minWidth: "180px" },
        positionsTeacherPreschoolGrant: { minWidth: "180px" },

        // Salaries
        salariesAdmin: { minWidth: "120px" },
        salariesSpecialEdTeachers: { minWidth: "170px" },
        salariesSpeechTeachers: { minWidth: "150px" },
        salariesPsychologists: { minWidth: "120px" },
        salariesSocialWorkerBCBA: { minWidth: "160px" },
        salariesSecretarial: { minWidth: "110px" },
        salariesParaEducators: { minWidth: "120px" },
        salariesTutors: { minWidth: "90px" },
        salariesParaEducatorsPT: { minWidth: "160px" },
        salariesOccupPhysTherapy: { minWidth: "160px" },
        salariesVanDriversMonitors: { minWidth: "160px" },
        salariesDriversGeneralServices: { minWidth: "160px" },
        salariesAltAfterSchool: { minWidth: "160px" },
        salariesSummerPrograms: { minWidth: "160px" },
        fieldTrips: { minWidth: "90px" },

        // Purchased Services
        psVehicleRental: { minWidth: "180px" },
        psTuition: { minWidth: "140px" },
        psModularClassroomLinks: { minWidth: "210px" },
        psAudiologicalMntc: { minWidth: "190px" },
        psCochlearImplantSupport: { minWidth: "220px" },
        psInterpreterServices: { minWidth: "190px" },
        psHearingImpaired: { minWidth: "180px" },
        psEvaluations: { minWidth: "180px" },
        psWorkExperienceProgram: { minWidth: "230px" },
        psLegalFees: { minWidth: "180px" },

        // Supplies / Materials
        supplies: { minWidth: "150px" },

        // Other / Offsets
        duesFees: { minWidth: "100px" },
        excessCostOffset: { minWidth: "110px" },
      },
    },
    {
      id: "actual",
      title: "Actual Spending",
      sectionKey: "Actual",
      fields: [
        // Positions
        "positionsAdmin",
        "positionsSpecialEdTeachers",
        "positionsSpeechTeachers",
        "positionsPsychologists",
        "positionsSocialWorkerBCBA",
        "positionsSecretarial",
        "positionsParaEducators",
        "positionsDriversGeneralServices",
        "positionsCertifiedIDEAB",
        "positionsClassifiedIDEAB",
        "positionsTeacherPreschoolGrant",

        // Salaries
        "salariesAdmin",
        "salariesSpecialEdTeachers",
        "salariesSpeechTeachers",
        "salariesPsychologists",
        "salariesSocialWorkerBCBA",
        "salariesSecretarial",
        "salariesParaEducators",
        "salariesTutors",
        "salariesParaEducatorsPT",
        "salariesOccupPhysTherapy",
        "salariesVanDriversMonitors",
        "salariesDriversGeneralServices",
        "salariesAltAfterSchool",
        "salariesSummerPrograms",
        "fieldTrips",

        // Purchased Services
        "psVehicleRental",
        "psTuition",
        "psModularClassroomLinks",
        "psAudiologicalMntc",
        "psCochlearImplantSupport",
        "psInterpreterServices",
        "psHearingImpaired",
        "psEvaluations",
        "psWorkExperienceProgram",
        "psLegalFees",

        // Supplies / Materials
        "supplies",

        // Other / Offsets
        "duesFees",
        "excessCostOffset",
      ],
      columnStyles: {
        year: { width: "100px", minWidth: "100px" },

        // Positions
        positionsAdmin: { minWidth: "120px" },
        positionsSpecialEdTeachers: { minWidth: "150px" },
        positionsSpeechTeachers: { minWidth: "150px" },
        positionsPsychologists: { minWidth: "130px" },
        positionsSocialWorkerBCBA: { minWidth: "150px" },
        positionsSecretarial: { minWidth: "110px" },
        positionsParaEducators: { minWidth: "120px" },
        positionsDriversGeneralServices: { minWidth: "160px" },
        positionsCertifiedIDEAB: { minWidth: "160px" },
        positionsClassifiedIDEAB: { minWidth: "180px" },
        positionsTeacherPreschoolGrant: { minWidth: "180px" },

        // Salaries
        salariesAdmin: { minWidth: "120px" },
        salariesSpecialEdTeachers: { minWidth: "170px" },
        salariesSpeechTeachers: { minWidth: "150px" },
        salariesPsychologists: { minWidth: "120px" },
        salariesSocialWorkerBCBA: { minWidth: "160px" },
        salariesSecretarial: { minWidth: "110px" },
        salariesParaEducators: { minWidth: "120px" },
        salariesTutors: { minWidth: "90px" },
        salariesParaEducatorsPT: { minWidth: "160px" },
        salariesOccupPhysTherapy: { minWidth: "160px" },
        salariesVanDriversMonitors: { minWidth: "160px" },
        salariesDriversGeneralServices: { minWidth: "160px" },
        salariesAltAfterSchool: { minWidth: "160px" },
        salariesSummerPrograms: { minWidth: "160px" },
        fieldTrips: { minWidth: "90px" },

        // Purchased Services
        psVehicleRental: { minWidth: "180px" },
        psTuition: { minWidth: "140px" },
        psModularClassroomLinks: { minWidth: "210px" },
        psAudiologicalMntc: { minWidth: "190px" },
        psCochlearImplantSupport: { minWidth: "220px" },
        psInterpreterServices: { minWidth: "190px" },
        psHearingImpaired: { minWidth: "180px" },
        psEvaluations: { minWidth: "180px" },
        psWorkExperienceProgram: { minWidth: "230px" },
        psLegalFees: { minWidth: "180px" },

        // Supplies / Materials
        supplies: { minWidth: "150px" },

        // Other / Offsets
        duesFees: { minWidth: "100px" },
        excessCostOffset: { minWidth: "110px" },
      },
    },
  ],
};

export function Program2700(props) {
  return (
    <ProgramBudget programId="2700" config={PROGRAM_2700_CONFIG} {...props} />
  );
}
